import { createBrowserRouter } from 'react-router-dom'

import { AppLayout } from './pages/_layouts/app'
import { Home } from './pages/app/home'
import { Solucoes } from './pages/app/solucoes'
import { Trabalhos } from './pages/app/trabalhos'
import { Clientes } from './pages/app/clientes'
import { Contato } from './pages/app/contato'
import { Case } from './pages/app/[slug]'

export const router = createBrowserRouter([
 {
  path: '/',
  element: <AppLayout />,
  children: [
   { path: '/', element: <Home /> },
   { path: '/solucoes', element: <Solucoes /> },
   { path: '/trabalhos', element: <Trabalhos /> },
   { path: '/clientes', element: <Clientes /> },
   { path: '/contato', element: <Contato /> },
   { path: '/:slug', element: <Case /> }
  ]
 }
])
